'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var ScheduleChangePanelController = function ScheduleChangePanelController($scope, $rootScope, ScheduleChange, managedEntitiesService, ScheduleChangeConstants, FeatureToggleService, transitionSearchCriteriaService, saveScheduleChangeService, $state, momentService, $log, UserSecureService) {
  var headerHeight = 28;
  var rowHeight = 35;
  $scope.wizardShown = undefined;
  $scope.defaultGridOptions = {
    headerHeight: headerHeight,
    rowHeight: rowHeight,
    suppressRowClickSelection: true,
    suppressCellSelection: true,
    pinnedColumnCount: 0,
    enableColResize: false,
    angularCompileRows: true,
    calculateGridHeight: function calculateGridHeight(numberOfRows, maxNumberOfRows) {
      // extra padding may differ because of horizontal scrollbar
      var padding = numberOfRows > maxNumberOfRows ? 22 : 7;
      maxNumberOfRows = maxNumberOfRows || numberOfRows;
      return headerHeight + padding + rowHeight * Math.min(numberOfRows, maxNumberOfRows);
    }
  };
  $scope.transitionButtonsEnabled = false;
  $scope.isWizardSelected = function () {
    return $scope.wizardShown !== undefined;
  };
  $scope.isMarketsWizard = function () {
    return $scope.wizardShown === ScheduleChangeConstants.ENTITIES.MARKETS;
  };
  $scope.isLegsWizard = function () {
    return $scope.wizardShown === ScheduleChangeConstants.ENTITIES.LEGS;
  };
  $scope.isFlightsWizard = function () {
    return $scope.wizardShown === ScheduleChangeConstants.ENTITIES.FLIGHTS;
  };
  $scope.$on('schedule-change:initWizard', function (event, wizard, entities) {
    managedEntitiesService.prepareData(wizard, entities).then(function (managedEntities) {
      transformOwnerToDisplayName(managedEntities);
      $scope.scheduleChange = new ScheduleChange(wizard, managedEntities);
      $scope.wizardShown = wizard;
    }, function (response) {
      var errorMsg = 'Error when retrieving ' + wizard + '. ' + response.statusText + ' (code ' + response.status + ')';
      $log.error('ScheduleChangePanelController: managedEntitiesService.prepareData - ' + errorMsg);
      toastr.error(errorMsg);
    });
  });
  $scope.$on('schedule-change:exitWizard', function () {
    $scope.wizardShown = undefined;
    $scope.transitionButtonsEnabled = false;
  });
  function createMarketName(entities) {
    return _.transform(entities, function (result, item) {
      result.push({
        market: item.origin + '-' + item.destination
      });
    });
  }
  function existingEntities() {
    if ($scope.isMarketsWizard()) {
      return _.filter($scope.scheduleChange.significantManagedEntities, function (entity) {
        return !entity.isNew;
      });
    }
    return _.filter($scope.scheduleChange.managedEntities, function (entity) {
      return !entity.isNew;
    });
  }
  $scope.noExistingEntities = function () {
    return existingEntities().length === 0;
  };

  /* this is required as a follow-up action after leaving Sponsor Flight Forecast */
  function combineManagedEntities(managedEntities) {
    var cloned = _.cloneDeep(managedEntities);
    var groups = _.groupBy(cloned, 'leg');
    _.forOwn(groups, function (legGroup) {
      var sponsors = _.compact(_.map(legGroup, 'flightSponsor'));
      _.forEach(legGroup, function (managedEntity) {
        managedEntity.flightSponsor = sponsors;
      });
    });
    return _.uniqBy(cloned, 'leg');
  }
  $scope.saveAndFinalize = function () {
    if ($scope.isMarketsWizard()) {
      $scope.saveMarketScheduleChange();
    } else if ($scope.isLegsWizard() || $scope.isFlightsWizard()) {
      $scope.saveFlightScheduleChange();
    }
  };
  function handleSuccess(msg) {
    $scope.transitionButtonsEnabled = true;
    toastr.success(msg);
  }
  function handleError(event, error) {
    saveScheduleChangeService.handleError(event, error);
  }
  function transformOwnerToUserId(significantManagedEntities) {
    _.forEach(significantManagedEntities, function (entity) {
      if (_.isObject(entity.owner)) {
        entity.owner = entity.owner.id;
      }
      delete entity.ownerDisplayName;
    });
  }
  function transformOwnerToDisplayName(significantManagedEntities) {
    _.forEach(significantManagedEntities, function (entity) {
      var userOwner = UserSecureService.getUserDisplayNameFromId(entity.owner);
      entity.ownerDisplayName = entity.owner;
      if (userOwner) {
        entity.ownerDisplayName = userOwner.getDisplayName();
      }
    });
  }
  $scope.saveMarketScheduleChange = function () {
    var managedEntities = $scope.scheduleChange.managedEntities;
    var significantManagedEntities = $scope.scheduleChange.significantManagedEntities;
    transformOwnerToUserId(managedEntities);
    transformOwnerToUserId(significantManagedEntities);
    saveScheduleChangeService.saveMarketScheduleChange(managedEntities, significantManagedEntities).then(function () {
      handleSuccess('Saved successfully');
    }, function (event, error) {
      handleError(event, error);
    });
  };
  $scope.saveFlightScheduleChange = function () {
    var managedEntities = combineManagedEntities($scope.scheduleChange.managedEntities);
    var significantManagedEntities = $scope.scheduleChange.significantManagedEntities;
    transformOwnerToUserId(managedEntities);
    transformOwnerToUserId(significantManagedEntities);
    saveScheduleChangeService.saveFlightScheduleChange(managedEntities, significantManagedEntities).then(function () {
      handleSuccess('Saved successfully');
    }, function (event, error) {
      handleError(event, error);
    });
  };
  $scope.openSplashPage = function () {
    $scope.$emit('schedule-change:exitWizard');
  };
  function prepareTransitionData(searchCriteria) {
    return {
      transitionData: {
        timestamp: momentService.now(momentService.FIELD.EVENT_TIME_STAMP),
        searchCriteria: searchCriteria
      }
    };
  }
  $scope.openMarketAnalysis = function () {
    var existingMarkets = existingEntities();
    if (existingMarkets.length === 0) {
      return;
    }
    var searchCriteria = transitionSearchCriteriaService.scheduleChangeToMarketAnalysis(createMarketName(existingMarkets));
    $state.go('app.market-analysis', prepareTransitionData(searchCriteria));
  };
  $scope.openFlightAnalysis = function () {
    var legs = existingEntities();
    if (legs.length === 0) {
      return;
    }
    var searchCriteria = transitionSearchCriteriaService.scheduleChangeToFlightAnalysis(legs);
    $state.go('app.flight-analysis', prepareTransitionData(searchCriteria));
  };
};
ScheduleChangePanelController.$inject = ['$scope', '$rootScope', 'ScheduleChangeFactory', 'ManagedEntitiesService', 'ScheduleChangeConstants', 'FeatureToggleService', 'TransitionSearchCriteriaService', 'SaveScheduleChangeService', '$state', 'MomentService', '$log', 'UserSecureService'];
module.exports = ScheduleChangePanelController;